module.exports = __webpack_public_path__ + "img/logo_header.65fb8189.png";